import Socials from "../socials/socials";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="ae-footer-container" data-testid="footer">
      <div className="waves">
        <div className="wave" id="wave1"></div>
        <div className="wave" id="wave2"></div>
        <div className="wave" id="wave3"></div>
        <div className="wave" id="wave4"></div>
      </div>
      <div className="ae-footer-content">
        <div className="ae-footer-main">
          <h3 className="ae-footer-title">ActEd.</h3>
          <p>Copyright © 2024 ActEd.</p>
          <p>All rights reserved</p>
          <a className="ae-privacy-policy" href="/privacy-policy">
            <p>Privacy policy</p>
          </a>
        </div>
        <div>
          <h3 className="ae-footer-title">Company</h3>
          <p>
            <a className="ae-link" href="/who-we-are">
              Who we are
            </a>
          </p>
          <p>
            <a className="ae-link" href="/training">
              Training
            </a>
          </p>
          <p>
            <a className="ae-link" href="/testimonials">
              Testimonials
            </a>
          </p>
          <p>
            <a className="ae-link" href="/get-in-touch">
              Get in touch
            </a>
          </p>
        </div>
        <div>
          <h3 className="ae-footer-title">Follow us</h3>
          <Socials theme={"light"} position={"left"} />
          <p className="ae-credits">Developed by: D. Mason & I. Ogrizovic</p>
        </div>
      </div>
    </footer>
  );
}
